import React from "react";
import {
  Check,
  SmartphoneNfc,
  Users,
  Calendar,
  Coins,
  ArrowRight,
  BarChart4,
} from "lucide-react";
import { Button } from "@/components/ui/button";

const HowItWorks = () => {
  const steps = [
    {
      number: "01",
      title: "Easy Registration",
      description:
        "Download our app and complete a simple verification process using your Aadhaar/PAN card. It's quick, secure, and hassle-free!",
      icon: <SmartphoneNfc size={24} className="text-blue-500" />,
      techDetail: "Government-approved verification process for your safety",
    },
    {
      number: "02", 
      title: "Join Savings Groups",
      description:
        "Join existing committee. Connect with trusted members and manage everything digitally.",
      icon: <Users size={24} className="text-indigo-500" />,
      techDetail: "Secure digital record keeping with instant updates",
    },
    {
      number: "03",
      title: "Simple Monthly Payments", 
      description:
        "Set up easy monthly payments through UPI or bank transfer. Get reminders and never miss a payment.",
      icon: <Calendar size={24} className="text-purple-500" />,
      techDetail: "Secure payment options through UPI and bank transfers",
    },
    {
      number: "04",
      title: "Smart Bidding System",
      description:
        "Participate in monthly auctions with helpful suggestions based on your savings goals and group history.",
      icon: <Coins size={24} className="text-teal-500" />,
      techDetail: "Fair and transparent bidding process for all members",
    },
  ];

  return (
    <section
      id="how-it-works"
      className="py-24 px-4 bg-gradient-to-b from-white to-blue-50"
    >
      <div className="container mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <div className="inline-flex items-center px-4 py-1.5 rounded-full bg-gradient-to-r from-blue-500 to-blue-600 shadow-lg border border-blue-400 text-white text-xs font-semibold mb-6 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5"
            style={{ textShadow: "0 1px 2px rgba(0,0,0,0.1)" }}>
            <Check size={12} className="mr-1.5" />
            Simple & Secure Platform
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-indigo-600 font-sans">
            How Our Platform Works
          </h2>
          <p className="text-gray-600 text-lg font-sans">
            We make digital digital committee easy, secure, and accessible for everyone. Join thousands of satisfied members today.
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {steps.map((step, index) => (
              <div 
                key={index} 
                className="bg-white p-6 rounded-xl shadow-md"
              >
                <div className="flex items-start">
                  <div className="mr-4">
                    <div className="w-12 h-12 rounded-xl flex items-center justify-center bg-gradient-to-r from-blue-500 to-indigo-500 text-white font-sans font-semibold">
                      {step.number}
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center mb-3">
                      <div className="p-2 rounded-lg bg-blue-50">
                        {step.icon}
                      </div>
                      <h3 className="text-lg font-sans font-semibold ml-3">
                        {step.title}
                      </h3>
                    </div>
                    <p className="text-gray-600 mb-3 font-sans text-sm">
                      {step.description}
                    </p>
                    <div className="text-xs bg-gray-50 border border-gray-100 rounded-lg p-2 text-gray-500">
                      <div className="flex items-center">
                        <BarChart4 size={12} className="mr-1 text-blue-500" />
                        <span className="font-sans">
                          {step.techDetail}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-10">
            <Button 
              className="text-base px-6 py-6 rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-sans"
              onClick={() => window.location.href = "/waitlist"}
            >
              Join the Waitlist
              <ArrowRight size={16} className="ml-2" />
            </Button>
            {/* <Button className="text-base px-6 py-6 rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-poppins">
              Join a Chit Fund Group
              <ArrowRight size={16} className="ml-2" />
            </Button> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;